const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTIgMzQxLjMzMyI+CjxyZWN0IHk9Ijg1LjMzNyIgZmlsbD0iIzExNDU3ZSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIzNDEuMzI2Ii8+Cjxwb2x5Z29uIGZpbGw9IiNkNzE0MWEiIHBvaW50cz0iNTEyLDI1NiA1MTIsNDI2LjY2MyAwLDQyNi42NjMgMjE1LjE4NSwyNTYgIi8+Cjxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iNTEyLDg1LjMzNyA1MTIsMjU2IDIxNS4xODUsMjU2IDAsODUuMzM3ICIvPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=CZ-76ccf075.mjs.map
